import { useContext } from 'react';
import { Icon, IconButton, Alert, AlertTypography, Typography } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { ProductType } from '../application/models/NewJoinSessionData';
import { getProductPrice, eligibleForERS } from '../utils/helpers';
import { AddOn } from '../components/AddOn';
import { getClubContent, ClubContentName, FEE_AMOUNT_PLACEHOLDER } from '../utils/getClubContent';

export interface ERSAddOnPros {
  setTooltipInfo: Function;
  setTooltipContent: Function;
  setDeleteInfo: Function;
  selectedERS: boolean;
}

export const ERSAddOn: (props: ERSAddOnPros) => JSX.Element = ({
  setTooltipInfo,
  setTooltipContent,
  setDeleteInfo,
  selectedERS,
}) => {
  const { membershipInfo, sessionData, updateProducts } = useContext(MembershipAppStateContext);
  const ersFee = membershipInfo?.membershipCost?.fees?.sameDayServiceFee;
  const ERSNotEligibleContent = (
    getClubContent(ClubContentName.ERSNotEligibleContent, sessionData.clubCode!) as string
  ).replaceAll(FEE_AMOUNT_PLACEHOLDER, `${ersFee}`);
  return (
    <>
      <div className="benefit-add-ons">
        <Typography className="benefit-add-ons-title" variant="b1Medium">
          Immediate Roadside Assistance
        </Typography>
        {eligibleForERS(membershipInfo, sessionData) ? (
          <IconButton
            aria-label="Immediate Roadside Assistance info"
            className="add-immediate-roadside-info-icon"
            onClick={() => {
              setTooltipInfo({
                tooltipTitle: 'Immediate Roadside Assistance',
              });
              setTooltipContent(
                `If you have a vehicle disablement before you join, that disablement will not be covered after you join as one of your four allowable service calls per membership year.  If you would like such service, you may request service for an additional $${ersFee} non-refundable service fee.`
              );
            }}
          >
            <Icon iconName="circle-info-regular" sx={{ color: '#707070' }} />
          </IconButton>
        ) : (
          <></>
        )}
      </div>
      {eligibleForERS(membershipInfo, sessionData) ? (
        <>
          <div className="ers-add-on">
            <AddOn
              onAdd={() => updateProducts('add', ProductType.ERS)}
              onDelete={() => {
                setDeleteInfo({
                  title: 'Are you sure you want to remove same day roadside service?',
                  warningContent: `If you have a vehicle disablement before you join, that disablement will not be covered after you join as one of your four allowable service calls per membership year. If you would like such service, you may request service for an additional $${ersFee} non-refundable service fee.`,
                  confirmRemove: () => {
                    updateProducts('remove', ProductType.ERS);
                  },
                });
              }}
              text="Get roadside help now"
              price={getProductPrice(membershipInfo, ProductType.ERS, sessionData)}
              isSelected={selectedERS}
              icon="van-shuttle-regular"
              type={ProductType.ERS}
            />
          </div>
          {selectedERS ? (
            <>
              <div className="information-container">
                <Alert severity="info" displayCloseButton={false}>
                  <AlertTypography className="ERS-info">
                    An additional ${ersFee} non-refundable service fee will be added to your purchase today for Roadside
                    Assistance for a vehicle disablement that occurred before you joined. That disablement is not
                    covered after you join as one of your four allowable service calls per membership year.
                  </AlertTypography>
                </Alert>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <Alert severity="info" displayCloseButton={false}>
            <AlertTypography className="ERS-info">{ERSNotEligibleContent}</AlertTypography>
          </Alert>
        </>
      )}
    </>
  );
};
